export default __webpack_public_path__ + "media/images/symbols/fuze-letters-1811abc4487cd959dd78b5234497e8d2.svg";